import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const RoleName = ({ role }) => {
    if (role === null || role === void 0 ? void 0 : role.label) {
        return _jsxs(_Fragment, { children: ["(", role === null || role === void 0 ? void 0 : role.label, ")"] });
    }
    return _jsx(_Fragment, {});
};
export default RoleName;
